import { routeToSpecificScope } from '../../helpers/helpersts';
import * as TYPES from "../types";
import {addLoadingFlag, changeMessageLoading, subLoadingFlag} from "./loading";
import {requestData} from "../../config/services/datasets";
import {SERVER} from "../../config/server.config";
import {paramBuilder, getTeamProps, saveDataEventsOnLocalStorage} from "../../helpers/helpers";
import { LEAGUES, GAME } from '../../config/constants';
import { updateMetaDataEvent, toMetaDataEvents } from './dataEvents';
import { gameReprocessFlag, playsIgnoreSavedFlag } from './flags';

export const replaceGames = (games) => {
  return {
    type: TYPES.REPLACE_GAMES,
    games
  };
};

export const setIgnorePlays= (plays, gameId) => {
  return {
    type: TYPES.SET_IGNORE_PLAYS,
    plays,
    gameId
  };
};

export const getGames = id => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    const teamId = id ? id : (getState().filters[scope].teamId ? getState().filters[scope].teamId : getState().user.teamId);
    const { league: teamLeague } = getTeamProps(teamId) || {};

    dispatch(addLoadingFlag(scope));
    const params = getState().filters[scope] ? JSON.parse(JSON.stringify(getState().filters[scope])) : {};
    params.teamId = teamId;

    const scores = teamLeague === LEAGUES.NFL ? await requestData(SERVER.GAMES_SCORE(teamId) + paramBuilder(params)) : undefined;
    const results = await requestData(SERVER.GAMES(teamId) + paramBuilder(params));

    if (scores) {
      if (scores.length === 0) {
        dispatch(changeMessageLoading(scope, 'No data matches your specified criteria'));
      }
      const list = scores.map((game) => {
        const gameMetrics = results && results.find(metric =>  metric.dsid === game.gameId);
        return {
          ...game,
          metrics: gameMetrics ? gameMetrics : null,
          // startDate: new Date(gameMetrics ? gameMetrics.startTime : game.ts),
          startDate: new Date(game.ts),
          end_date: gameMetrics ? new Date(gameMetrics.endTime) : null,
        };
      });
      dispatch(replaceGames(list));
    } else if (teamLeague !== LEAGUES.NFL) {
      if (!results || !results.length) {
        dispatch(changeMessageLoading(scope, 'No data matches your specified criteria'));
      } else {
        const gamesIds = [];
        const list = results.map(game => {
          const { name: teamName, ...metrics } = game;

          const gameEvent = {
            ...game,
            gameId: game.dsid,
            league: teamLeague,
            type: GAME,
            gameType: teamLeague
          };

          gamesIds.push(game.dsid);
          dispatch(updateMetaDataEvent(game.dsid, toMetaDataEvents(gameEvent)));

          return {
            metrics,
            teamName,
            completed: true,
            gameId: game.dsid,
            startDate: new Date(game.startTime),
            end_date: new Date(game.endTime)
          };
        });

        dispatch(replaceGames(list));
        saveDataEventsOnLocalStorage(gamesIds);
      }
    }

    dispatch(subLoadingFlag(scope));
  };
};

export const getIgnorePlays = (gameId) =>{
  return async (dispatch) => {
  const results = await requestData(SERVER.IGNORE_PLAYS(gameId));
  let defaultCustom;
  if(!results || results.length === 0){
    defaultCustom =[];
    dispatch(setIgnorePlays(defaultCustom, gameId));
  }else{
    defaultCustom = JSON.parse(results[0]);
    dispatch(setIgnorePlays(defaultCustom, gameId));
  }
};   
};

export const saveIgnorePlays = (gameId, ignorePlays) =>{
  return async (dispatch) => {
    const plays = ignorePlays;
    const jsonBody = JSON.stringify(plays);
    fetch(SERVER.IGNORE_PLAYS(gameId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: jsonBody
    })
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .finally(() => {
        dispatch(getIgnorePlays(gameId));
        dispatch(playsIgnoreSavedFlag(true));
      });
};   
};

export const reprocessGame = (gameId) =>{

  return async (dispatch) => {
    fetch(SERVER.REPROCESS_GAME(gameId))
    .then(response => response.json())
    .then(data => {
      if(data.code === 0){
        dispatch(gameReprocessFlag(data.code.toString()));
      }
      if(data.code){
        dispatch(gameReprocessFlag(data.code.toString()));
      }
    })
    .catch(error => {
      dispatch(gameReprocessFlag('-1'));
    });
  };
 
};

